import React from 'react';
import { Colors } from '@common/tokens';
import { clsx } from 'clsx';

export const Divider = ({
  className,
  gutter = false,
  fullWidth = true,
  secondary = false,
}: {
  className?: string;
  gutter?: boolean | number;
  fullWidth?: boolean;
  secondary?: boolean;
}) => {
  const borderColor = secondary ? Colors.steelLighter : Colors.steel;

  return (
    <>
      <hr
        className={clsx({
          'wk-divider': true,
          [className || '']: true,
          'wk-divider--gutter': typeof gutter === 'boolean' ? gutter : true,
        })}
      />
      <style jsx>{`
        .wk-divider {
          ${fullWidth ? 'width: 100%' : ''};
          border-top: none;
          border-bottom: solid 1px ${borderColor};
          margin: 0;
        }

        .wk-divider--gutter {
          margin: ${typeof gutter === 'boolean' ? 24 : gutter}px 0;
        }
      `}</style>
    </>
  );
};
